// extracted by mini-css-extract-plugin
export default {"list":"language_list__WOXXA","inactive":"language_inactive__zJrE1","active":"language_active__EL2um"};